import { Component, OnInit } from '@angular/core';
import { SmartintegService } from '../../../services/smartinteg.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  // Exemplo de dados para os cards
  stats = {
    provedores: 0,
    processos: 0,
    recursos: 0,
    execucoes: 0
  };

  // Exemplo de dados para a tabela
  ultimasExecucoes: any[] = [];
  processosAtivos: any[] = [];

  loading: boolean = true;

  constructor(private smartintegService: SmartintegService) { }

  ngOnInit(): void {
    // Aqui você pode carregar os dados do dashboard
    this.loading = false;
    // Exemplo:
    // this.carregarEstatisticas();
    // this.carregarUltimasExecucoes();
  }
}
